module.exports = __webpack_public_path__ + "img/pr-12.4345b986.png";